module.exports = __webpack_public_path__ + "static/media/32.c26dcf19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/32.svg
// module id = 147
// module chunks = 0